<template>
  <v-expansion-panel style="border-radius: 6px">
    <v-expansion-panel-header
      style="font-weight: 600; color: #746b6b; font-size: 12x"
    >
      {{ $t("events.event-config.cancellation-period") }}
    </v-expansion-panel-header>
    <v-expansion-panel-content class="py-6">
      <v-radio-group
        v-model="
          $produtos_gerenciar.cadastro.dados_cadastrais.controla_cancelamento
        "
      >
        <v-row>
          <v-col cols="12" class="mb-4">
            <v-radio
              :label="$t('events.event-config.default-cancellation')"
              class="rounded-lg pa-2"
              style="border: 1px solid rgb(0 0 0 / 42%)"
              active-class="active-class"
              :value="1"
            ></v-radio>
          </v-col>
          <v-col cols="12">
            <v-radio
              :label="$t('events.event-config.custom-cancellation')"
              :value="2"
              class="rounded-lg pa-2"
              style="border: 1px solid rgb(0 0 0 / 42%)"
              active-class="active-class"
            ></v-radio>
          </v-col>
        </v-row>
        <v-row v-if="hasCustom" class="mt-4">
          <v-col cols="5">
            <BaseTextField
              v-model="
                $produtos_gerenciar.cadastro.dados_cadastrais
                  .dias_canc_apos_compra
              "
              placeholder="0"
              hide-details
              type="number"
            />
          </v-col>
          <v-col class="align-center d-flex">
            <span>{{ $t("events.event-config.days-after-purchase") }}</span>
          </v-col>
          <v-col cols="5">
            <BaseTextField
              v-model="
                $produtos_gerenciar.cadastro.dados_cadastrais
                  .horas_canc_antes_evento
              "
              placeholder="0"
              hide-details
              type="number"
              :options="options5"
            />
          </v-col>
          <v-col class="align-center d-flex">
            <span>{{ $t("events.event-config.hours-before-event") }}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="mt-4">
            <v-radio
              :label="$t('events.event-config.disabled-cancellation')"
              :value="0"
              class="rounded-lg pa-2"
              style="border: 1px solid rgb(0 0 0 / 42%)"
              active-class="active-class"
            ></v-radio>
          </v-col>
        </v-row>
      </v-radio-group>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import mixins from "@/mixins";
import BaseTextField from "@/components/forms/BaseTextField.vue";

export default {
  name: "OptionCancellation",
  mixins: [mixins],
  components: {
    BaseTextField,
  },
  data() {
    return {
      options5: {
        locale: "pt-BR",
        suffix: "UTC-3",
      },
    };
  },
  watch: {
    // PADRÃO 7 DIAS E 48H
    "$produtos_gerenciar.cadastro.dados_cadastrais.controla_cancelamento"(e) {
      if (e == 0) {
        this.$produtos_gerenciar.cadastro.dados_cadastrais.dias_canc_apos_compra = 7;

        this.$produtos_gerenciar.cadastro.dados_cadastrais.horas_canc_antes_evento = 24;
      }
      if (e == 1) {
        this.$produtos_gerenciar.cadastro.dados_cadastrais.dias_canc_apos_compra = 7;

        this.$produtos_gerenciar.cadastro.dados_cadastrais.horas_canc_antes_evento = 24;
      }
    },
  },
  computed: {
    hasCustom() {
      return (
        this.$produtos_gerenciar.cadastro.dados_cadastrais
          .controla_cancelamento === 2
      );
    },
  },
  created() {
    if (
      this.$produtos_gerenciar.cadastro.dados_cadastrais
        .dias_canc_apos_compra != 7 ||
      this.$produtos_gerenciar.cadastro.dados_cadastrais
        .horas_canc_antes_evento != 24
    ) {
      this.$produtos_gerenciar.cadastro.dados_cadastrais.controla_cancelamento = 2;
    }
  },
};
</script>

<style>
.active-class {
  background-color: #e6f7ff !important;
  border-color: #91d5ff !important;
  color: #1890ff !important;
}
</style>
